import React, { useState } from "react";

const SanaviBookingForm = () => {
const today = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    passengers: "",
    vehicle: "",
    pickup: "",
    destination: "",
    journeyDate: "",
    returnDate: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleWhatsAppSubmit = () => {

    const message = `
🚖 *Sanavi Travels Booking Request*

👤 Name: ${formData.name}
📞 Phone: ${formData.phone}
👥 Passengers: ${formData.passengers}
🚘 Vehicle: ${formData.vehicle}
📍 Pickup: ${formData.pickup}
📌 Destination: ${formData.destination}
📅 Journey Date: ${formData.journeyDate}
🔁 Return Date: ${formData.returnDate}
    `;

    const whatsappURL = `https://wa.me/917387507373?text=${encodeURIComponent(message)}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <section className="sanavi-booking-section">

      <div className="booking-container">

       

        <p className="booking-subtitle text-white">
          ONLINE BOOKING
        </p>

        {/* <h2 className="booking-title">
          Confirm Your Booking Now!
        </h2> */}

        <div className="booking-grid">

          <div className="form-group">
            <label>Your Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter Your Name"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              placeholder="Enter Mobile Number"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Number of Passenger</label>
            <input
              type="number"
              name="passengers"
              placeholder="Passengers"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Type of Vehicle</label>

            <select
              name="vehicle"
              onChange={handleChange}
            >
              <option value="">Select Vehicle</option>
              <option>Swift Dzire</option>
              <option>Aura</option>
              <option>Ertiga</option>
              <option>Innova</option>
              <option>Innova Crysta</option>
              <option>Urbania</option>
              <option>13 Seater Traveller AC</option>
              <option>13 Seater Traveller Non AC</option>
              <option>17 Seater Traveller AC</option>
              <option>17 Seater Traveller Non AC</option>
              <option>20 Seater Traveller AC</option>
              <option>20 Seater Traveller Non AC</option>
              <option>26 Seater AC</option>
              <option>26 Seater Non AC</option>
              <option>32 Seater AC</option>
              <option>32 Seater Non AC</option>
              <option>35 Seater AC</option>
              <option>35 Seater Non AC</option>
              <option>40 Seater AC</option>
              <option>40 Seater Non AC</option>
              <option>45 Seater AC</option>
              <option>45 Seater Non AC</option>
            </select>
          </div>

          <div className="form-group">
            <label>Pickup Location</label>
            <input
              type="text"
              name="pickup"
              placeholder="Pickup Location"
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Destination</label>
            <input
              type="text"
              name="destination"
              placeholder="Destination"
              onChange={handleChange}
            />
          </div>

<div className="form-group">  <label>Journey Date</label>  <input    type="date"    name="journeyDate"    min={today}    onChange={handleChange}  /></div><div className="form-group">  <label>Return Date</label>  <input    type="date"    name="returnDate"    min={formData.journeyDate || today}    onChange={handleChange}  /></div>

        </div>

        <div className="submit-btn-box">
          <button onClick={handleWhatsAppSubmit}>
            Book via WhatsApp
          </button>
        </div>

      </div>

    </section>
  );
};

export default SanaviBookingForm;